import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useWorkspace } from './workspace';

/**
 * Keep one person’s setup milestones separate from the rest of the workspace.
 * `interval` is shorter while a setup screen is waiting for the first call or recording.
 */
export function usePhoneSyncProgress(employeeId?: number, enabled = true, poll = true, interval = 30_000) {
  const { orgId } = useWorkspace();
  const hasCalls = useQuery({
    queryKey: ['hasCalls', orgId, employeeId ?? 'all'],
    queryFn: () => api.calls.hasAnyCall(orgId, employeeId),
    enabled,
    staleTime: (q) => (q.state.data ? Infinity : 20_000),
    refetchInterval: (q) => (poll && !q.state.data ? interval : false),
  });
  const hasRecordings = useQuery({
    queryKey: ['hasRecordings', orgId, employeeId ?? 'all'],
    queryFn: () => api.calls.hasAnyCall(orgId, employeeId, true),
    enabled: enabled && Boolean(hasCalls.data),
    staleTime: (q) => (q.state.data ? Infinity : 20_000),
    refetchInterval: (q) => (poll && !q.state.data ? interval : false),
  });
  return { hasCalls, hasRecordings };
}
